<template>
  <div class="main-role">

    <main>
      <header>
        <h3>角色管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:role:save')" type="primary" icon="plus" @click="handleOpen('添加')"
          >添加</a-button
          >
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText" >
            <a-input-search
                placeholder="角色名称"
                style="width: 200px; "
                allow-clear
                :loading="btnLoad"
                v-model.trim="pagination.searchText"
                @input="searchTextChange"
            />
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                style="width: 180px;"
                @change="searchChange"
                placeholder="选择部门"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>

        </a-form-model>

      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered :data-source="tableData" :pagination="queryCondition"  :scroll="{ y: 560 }" :loading="tableLoad"  @change="handleTableChange">
        <span slot="customTitle">角色名称</span>
        <span slot="action" slot-scope="text, record" class="table-action-box">
            <a-tooltip  content="" v-if="$IA('system:role:update') && record.roleKey !='administrator'" title="修改" placement="top" effect="light">
              <i class="table-edit"  @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:role:delete') && record.roleKey !='administrator'" title="删除" placement="top" effect="light">
              <i class="table-delected"  @click="handleOpen('删除', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:role:grant') && record.roleKey !='administrator'" title="分配资源" placement="top" effect="light">
              <i class="table-segmentPerformance"  @click="resourcesOpen('分配资源', record)" ></i>
            </a-tooltip>
        </span>
      </a-table>
    </main>

    <!-- 添加 -->
    <a-modal
      centered
      :title="modalTitle + '角色'"
      :visible="modalVisible"
      :confirm-loading="submitLoad"
      @ok="handleOk"
      :width="modalTitle == '删除' ? '420px' : '580px'"
      @cancel="resetForm"
      :maskClosable="false"
    >
      <a-form-model
        v-if="['添加', '修改'].includes(modalTitle)"
        layout="vertical"
        :model="addForm"
        ref="addForm"
        :rules="roleFormRules"
      >
        <a-form-model-item prop="id" v-show="false">
          <a-input v-model="addForm.id" placeholder="请输入" />
        </a-form-model-item>
<!--        <a-form-model-item label="角色KEY" prop="roleKey">-->
<!--          <a-input :disabled="modalTitle=='修改'" v-model="addForm.roleKey" placeholder="请输入" />-->
<!--        </a-form-model-item>-->
        <a-form-model-item label="角色名称" prop="name">
          <a-input :disabled="modalTitle=='修改'" v-model="addForm.name" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="部门" prop="orgId">
          <a-tree-select
              :disabled="modalTitle=='修改'"
              v-model='addForm.orgId'
              allowClear
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="选择部门"
              tree-default-expand-all
              show-search
              :filterTreeNode="filter_tree_node"
              :replaceFields="{ title: 'name', key: 'id',value:'id' }"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-input v-model="addForm.description" placeholder="请输入" />
        </a-form-model-item>
        <template slot="footer">
          <a-button key="back" @click="modalVisible = false"> 取消 </a-button>
          <a-button
            key="submit"
            type="primary"
            @click="handleOk"
          >
            提交
          </a-button>
        </template>
      </a-form-model>
      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该角色,是否继续?</p>
      </div>
    </a-modal>

    <!-- 分配资源 -->
    <a-modal
      centered
      :keyboard="false"
      title="分配权限"
      :visible="resourcesRoleVisible"
      width="600px"
      :confirm-loading="submitLoad"
      @cancel="ResetTree"
      :footer="null"
      :maskClosable="false"
    >
      <a-spin :spinning="submitLoad" style="padding-bottom: 20px;">
        <a-tabs  :activeKey="activeKey"   @change="callback">
          <a-tab-pane key="1" tab="功能权限">
            <div class="trreSelect">
              <a-tree
              v-if="this.resourcesData && this.resourcesData.length > 0"
              checkable
              checkStrictly
              v-model="checkedKeys"
              :tree-data="resourcesData"
              :replace-fields="replaceFields"
              :expandedKeys.sync="expandedKeys"
              @check="treeCheck"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="数据权限">
          <div class="trreSelect">
            <a-tree
              v-if="this.resourcesData && this.resourcesData.length > 0"
              checkable
              checkStrictly
              v-model="checkedKeys"
              :tree-data="resourcesData"
              :replace-fields="replaceFields"
              :expandedKeys.sync="expandedKeys"
              @check="treeCheck"
              />
            </div>
          </a-tab-pane>

        </a-tabs>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>


import {notification} from "ant-design-vue";
export default {
  data() {
    return {
      btnLoad: false,
      tableLoad:false,
      submitLoad:false,
      pagination: {
        searchText: "",
        state: undefined,
        orgId:undefined,
        pageSize: 10,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      queryCondition: {},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          width: 220,
          dataIndex: "name",
          key: "name",
          slots: { title: "customTitle" },
          scopedSlots: { customRender: "name" },
          ellipsis: true,
        },

        {
          title: "部门",
          dataIndex: "orgName",
          key: "orgName",
          ellipsis: true,
        },
        {
          title: "描述",
          dataIndex: "description",
          key: "description",
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          ellipsis: true,
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 120,
        },
      ],
      priorityIcon: {
        0: require("../assets/images/low.png"),
        1: require("../assets/images/normal.png"),
        2: require("../assets/images/height.png"),
      },
      // 优先级字典
      priorityName: {
        0: "低",
        1: "中",
        2: "高",
        3: "已继承"
      },
      formLayout:"inline",
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: "",
      // 添加/删除api
      saveApi:"",
      // 单条数据
      singleDta:"",
      // 添加表单
      addForm: {
        id: "",
        // roleKey: "",
        name: "",
        status: 0,
        orgId:undefined,
        description: "",
      },
      //部门下拉框
      treeData: [],
      roleFormRules: {
        // roleKey: [{ required: true, max: 50, message: "角色KEY最长不能超过50字符且不可为空" }],
        name: [{ required: true, max: 20, message: "角色名称最长不能超过20字符且不可为空" }],
        status: [{ required: true, message: "状态不能为空" }],
        orgId: [{ required: true, message: "部门不能为空" }],
        description: [{ required: false, max: 250, message: "描述最长不能超过250字符" }],
      },
      // 分配资源
      activeKey:'1',
      treeApi:"",
      grantApi:"",
      distributionData:{},
      resourcesRoleVisible:false,
      resourcesData: [],
      expandedKeys:[],
      replaceFields: {
        children: 'children',
        title: 'name',
        key:'id',
        disabled:'disabled'
      },
      checkedKeys: [],
      replaceForm:{
        id:"",
        resourceIds:[]
      },
      // 分页参数
      pagCurrent:{},
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
     // 重置表单通用方法
    resetForm(){
      if ( this.modalTitle =='添加' || this.modalTitle =='修改' ) {
          this.$refs.addForm.resetFields()
      }
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch(){
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    ResetTree(){
      this.activeKey = '1';
      this.resourcesRoleVisible = false
      this.checkedKeys = []
      this.expandedKeys = []
    },
    // 打开模态框
    handleOpen(title,data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.singleDta = data
        switch (title) {
          case "添加":
            this.saveApi= '/role/save'
            break;
          case "修改":
            this.saveApi = '/role/update'
            this.$nextTick(()=>{
              this.addForm = this.$lodash.pick(
                this.singleDta,
                this.$lodash.keys(this.addForm)
              );
            })
            break;
          case "删除":
            break;
        }
    },
    // 确认模态框
    handleOk() {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.addForm);
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange(this.modalTitle == "添加"? this.pagination:this.pagCurrent);
                  this.resetForm()
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.submitLoad = true;
        this.axios
          .delete("/role/delete/" + this.singleDta.id)
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange(this.pagCurrent);
              this.modalVisible = false;
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
      }
    },
    // 打开分配资源
    resourcesOpen(title,data){
     this.replaceForm.id = data.id
     this.distributionData = data
     this.resourcesRoleVisible = true
     this.callback('1')
    },
    // 部门下拉框
    allorgList() {
      this.axios
          .post("/org/findOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },

    // treeMap(data){
    //
    //    if (data) {
    //       return data.id
    //    }else{
    //       data.children.map(x=>{
    //         console.log(x.name);
    //         return this.treeMap(x)
    //       })
    //    }
    //
    //
    //
    // },

    // 复选框选中监听
    treeCheck(checkedIds, {checked, checkedNodes, node, event}){
      console.log( this.activeKey )
      // console.log(checkedIds, checked, checkedNodes, node, event);
      // 存在子节点时
      if (node.$children.length>0) {
        if (checked===true) {
          let tempChildIds = this.treeMap(node.dataRef)
          this.checkedKeys = this.$lodash.difference(this.checkedKeys.checked,tempChildIds).concat(tempChildIds)
          this.replaceForm.resourceIds = this.checkedKeys
          this.resourcesSubmit()
          // this.$confirm({
          //   title: '请您选择勾选类型！',
          //   content: '您想 [全选] '+node.title+'及其所有子级权限？还是仅 [单选] '+node.title+'权限？',
          //   okText: '全选',
          //   cancelText: '单选',
          //   onOk:() => {
          //     console.log('全选');
          //     let tempChildIds = this.treeMap(node.dataRef)
          //     this.checkedKeys = this.$lodash.difference(this.checkedKeys.checked,tempChildIds).concat(tempChildIds)
          //     this.replaceForm.resourceIds = this.checkedKeys
          //     this.resourcesSubmit()
          //   },
          //   onCancel:() => {
          //     console.log('单选');
          //     this.replaceForm.resourceIds = checkedIds.checked
          //     this.resourcesSubmit()
          //   },
          // });
        }
        if (checked===false) {
          let tempChildIds = this.treeMap(node.dataRef)
          this.checkedKeys = this.$lodash.difference(this.checkedKeys.checked,tempChildIds)
          this.replaceForm.resourceIds = this.checkedKeys
          this.resourcesSubmit()
          // this.$confirm({
          //   title: '请您选择取消勾选类型！',
          //   content: '您想 [取消全选] '+node.title+'及其所有子级权限？还是仅 [取消单选] '+node.title+'权限？',
          //   okText: '取消全选',
          //   cancelText: '取消单选',
          //   onOk:() => {
          //     console.log('取消全选');
          //     let tempChildIds = this.treeMap(node.dataRef)
          //     this.checkedKeys = this.$lodash.difference(this.checkedKeys.checked,tempChildIds)
          //     this.replaceForm.resourceIds = this.checkedKeys
          //     this.resourcesSubmit()
          //   },
          //   onCancel:() => {
          //     console.log('取消单选');
          //     this.replaceForm.resourceIds = checkedIds.checked
          //     this.resourcesSubmit()
          //   },
          // });
        }
      } else {

        this.replaceForm.resourceIds = checkedIds.checked
        this.resourcesSubmit()
      }
    },
    treeMap(data){

      let treeChildIds = [data.id]

      if (data.children&&data.children.length>0) {
             data.children.forEach((d)=>{
               // 判断数据权限  点击勾选，取消选中时，判断第一次默认选中的数据是否传值
               // 功能权限不判断
               if (!d.disabled){
                 treeChildIds = treeChildIds.concat(this.treeMap(d))
               }
            })
          }
          return treeChildIds




    },
    callback(val){
      this.activeKey = val
      this.resourcesData = []
      switch (val) {
        case '1':
          this.treeApi = "/resource/tree/"
          this.grantApi = '/role/grant'
          break;
       case '2':
          this.treeApi = "/org/tree/"
          this.grantApi = '/role/grantOrg'
          break;
      }
      this.axios
          .get(this.treeApi + this.distributionData.id)
          .then((res) => {
            if (res.code === 200) {
              this.resourcesData = res.data.allResource
              if (val == '1'){
                this.resourcesData.forEach((item)=>{
                  if (this.$store.state.user.userInfo.roleType == 1){
                    item.disabled = false
                  }
                  if (item.name == '工作台'){
                    item.disabled = true
                  }
                })
              }
              this.checkedKeys  = res.data.checkedResourceIds
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 分配资源提交
    resourcesSubmit() {
      // 判断 去掉工作台
      if (this.activeKey == 1 ){
        this.replaceForm.resourceIds = this.replaceForm.resourceIds.filter((item)=>{
           return item != '183aa434ca88d0bdedf5d83ac14ce497'
        })
      }
      this.submitLoad = true;
      this.axios
        .post(this.grantApi, this.replaceForm)
        .then((res) => {
          this.submitLoad = false;
          if (res.code === 200) {
            notification.success({
              message: res.message,
              duration: 3,
              customClass: "batch-import",
            })
          } else {
            this.callback('1')
          }
        })
        .catch((err) => {
          this.submitLoad = false;
          console.log(err);
          this.callback('1')
        });
    },
    // 监听搜索输入框输入
    searchTextChange(val){
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =   pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
        .post("/role/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.searchChange()
    this.allorgList()
  },
};
</script>

<style lang="scss" scoped>
.main-role {
  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }

    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
    .img-lc {
      vertical-align: middle;
      margin-right: 5px;
      margin-top: -1px;
    }
    .ant-tag {
      border-radius: 16px;
    }
  }
}

  // 分配资源样式
 ::v-deep .ant-modal-content{
    .ant-modal-header{
      // border-bottom: 1px solid #e8e8e8;
    }
    .ant-modal-body{
      .ant-tabs-bar{
        border-bottom: none;
      }
    }
    .trreSelect{
      max-height: 380px;
      overflow: auto;
    }
  }
</style>
